// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"AGyu-","body":"pp5Nz","body-art":"XUPQe","rc-tabs-bar":"PYmvz","rc-tabs-tab":"eHjn-","rc-tabs-tab-active":"cJ3ve","base":"_1H61N"};